/**
 * 通过百分比，使HEX颜色变暗
 * @param {string} color 要更改的颜色
 * @param {number} amount 更改颜色的的值
 * @returns {string} 混合后的颜色16进制
 */
export function darken(color, amount) {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color
  amount = Math.trunc((255 * amount) / 100)
  return `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(
    color.substring(2, 4),
    amount
  )}${subtractLight(color.substring(4, 6), amount)}`
}

/**
 * 通过百分比，使HEX颜色变亮
 * @param {string} color 要更改的颜色
 * @param {number} amount 更改颜色的的值
 * @returns {string} 处理后的颜色表示为HEX
 */
export function lighten(color, amount) {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color
  amount = Math.trunc((255 * amount) / 100)
  return `#${addLight(color.substring(0, 2), amount)}${addLight(
    color.substring(2, 4),
    amount
  )}${addLight(color.substring(4, 6), amount)}`
}

/**
 * 增强颜色，通过百分比与十六进制颜色的R、G或B相加
 * @param {string} color 要更改的颜色
 * @param {number} amount 更改颜色的的值
 * @returns {string} 增强后的颜色
 */
function addLight(color, amount) {
  const cc = parseInt(color, 16) + amount
  const c = cc > 255 ? 255 : cc
  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
}

/**
 * 减弱颜色，通过百分比减去HEX颜色的R、G或B
 * @param {string} color 要更改的颜色
 * @param {number} amount 更改颜色的的值
 * @returns {string} 减弱后的颜色
 */
function subtractLight(color, amount) {
  const cc = parseInt(color, 16) - amount
  const c = cc < 0 ? 0 : cc
  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
}


/**
 * 16进制转换RGBA颜色
 * @param {*} hex 16进制颜色 
 * @param {*} opacity 透明度
 * @returns 
 */
export function hexToRgba(hex, opacity) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  opacity = opacity >= 0 && opacity <= 1 ? Number(opacity) : 1
  return result
    ? 'rgba(' +
        [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), opacity].join(
          ','
        ) +
        ')'
    : hex
}
